class BranchioshareController {
  constructor($timeout, $branchio) {
    this.name = "branchioshare";

    this.$timeout = $timeout;
    this.$branchio = $branchio;
  }

  $onInit() {
    this.num = Math.random();

    $(document.getElementById(`copy-link-${this.num}`)).tooltip({
      container: "body",
      trigger: "manual",
    });

    $(document.getElementById(`branchModal-${this.num}`)).on("hide.bs.modal", function (e) {
      $(document.getElementById(`copy-link-${this.num}`)).tooltip("hide");
    });

    console.log("what is the job");
    console.dir(this.jobble);
  }

  share() {
    $(document.getElementById(`branchModal-${this.num}`)).modal("toggle");

    console.log("lets take a look at the job");
    console.dir(this.jobble);

    const jobbleId = this.jobble.id;
    const title = this.jobble.title;
    const company = this.jobble.companyName;
    let url = "";

    console.log(jobbleId, title, company);

    if (this.jobble.partnerPostContent) {
      url = this.jobble.partnerPostContent.url;
    }

    this.$branchio.createLinks(jobbleId, title, company, url).then((links) => {
      console.log("receieved many link here:", links);
      this.$timeout(() => {
        this.link = links.email;
        this.twitterLink = `https://twitter.com/intent/tweet?text=Check out this job! ${links.twitter}`;
        this.facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${links.facebook}`;
        // eslint-disable-next-line max-len
        this.linkedInLink = `https://www.linkedin.com/shareArticle?mini=true&url=${links.linkedin}&title=&summary=Check out this job!&source=`;
      });
    });
  }

  open(link) {
    link = link || "https://jobble.com";
    window.open(link, "_blank", "location=yes,height=570,width=520,scrollbars=yes,status=yes");
  }

  copy() {

    console.log("copy");

    const copyText = document.getElementById(`copyInput-${this.num}`);

    copyText.select();
    copyText.setSelectionRange(0, 99999);

    document.execCommand("copy");

    if (window.getSelection) {
      window.getSelection().removeAllRanges();
    } else if (document.selection) {
      document.selection.empty();
    }

    $(document.getElementById(`copy-link-${this.num}`)).tooltip("show");
    setTimeout(() => {
      $(document.getElementById(`copy-link-${this.num}`)).tooltip("hide");
    }, 750);
  }

}

BranchioshareController.$inject = ["$timeout", "branchio"];

export default BranchioshareController;



// WEBPACK FOOTER //
// ./client/app/common/branchioshare/branchioshare.controller.js